import { Component, OnInit } from '@angular/core';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { Cell } from '../../cell';
import { LayoutService } from '../../layout.service';

@Component({
  selector: 'app-cell-icon',
  templateUrl: './cell-icon.component.html',
  styleUrls: ['./cell-icon.component.less']
})
export class CellIconComponent extends Cell {
  constructor(
    public layoutService: LayoutService,
    public drawerService: NzDrawerService
  ) {
    super(layoutService, drawerService);
  }
}
